import { render } from "./SegmentControl_slider.vue?vue&type=template&id=3330ed70"
import script from "./SegmentControl_slider.vue?vue&type=script&lang=js"
export * from "./SegmentControl_slider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__